import { useEffect, useState } from 'react';
import { ButtonSecondary, ButtonSize, IconEdit, PermissionEnum } from '@ui/src';
import { useAppSelector } from '@store';
import Card from '../../partial/card/card';
import GeneralUserInfoBlock from './general-user-info-block';
import GeneralUserInfoContacts from './general-user-info-contacts';
// import GeneralUserInfoApp from './general-user-info-app';
// import GeneralUserInfoRow from './general-user-info-row';
import GeneralUserInfoProducts from './genera-user-info-products';
import { CustomerStatus, OrganizationType } from '../../../hoc/customers/types';
import GeneralUserInfoRow from './general-user-info-row';
import { GeneralUserInfoTypes } from '../types';

import cn from './overview-content.module.css';

const GeneralUserInfo = ({
  isLoading,
  generalUserInfo,
  control,
  onInfoSubmit,
  baseUserInformation,
  requestInProgress,
  isSuccess,
  recoveryInProgress,
  onResetPassword,
  globalError,
  errors,
  setConvertPopuVisible,
  convertToIndividualAvailable,
  status,
}: GeneralUserInfoTypes) => {
  const [edit, setEdit] = useState(false);

  const { activePermissions } = useAppSelector(
    (state) => state.customersDictionaries,
  );

  useEffect(() => {
    if (isSuccess) {
      setEdit(false);
    }
  }, [isSuccess]);

  return (
    <Card title="General info" isLoading={isLoading}>
      <GeneralUserInfoBlock
        generalUserInfo={generalUserInfo}
        baseUserInformation={baseUserInformation}
        control={control}
        globalError={globalError}
        errors={errors}
        edit={edit}
      />
      {generalUserInfo?.type !== OrganizationType.COMPANY_OFFICIAL && (
        <GeneralUserInfoProducts
          baseUserInformation={baseUserInformation}
          control={control}
          edit={edit}
        />
      )}
      <GeneralUserInfoContacts
        baseUserInformation={baseUserInformation}
        control={control}
        recoveryInProgress={recoveryInProgress}
        onResetPassword={onResetPassword}
        edit={edit}
      />
      {baseUserInformation?.type === OrganizationType.COMPANY_OFFICIAL &&
        setConvertPopuVisible &&
        convertToIndividualAvailable && (
          <div className={cn.convertToIndividaul}>
            <div className={cn.generalUserInfoBlockItem}>
              <GeneralUserInfoRow title="Customer type" type="default">
                <ButtonSecondary
                  size={ButtonSize.SMALL}
                  className={`button-white ${cn.passwordButton}`}
                  text={
                    recoveryInProgress
                      ? 'Loading...'
                      : ' Convert to an individual customer'
                  }
                  onClick={() => setConvertPopuVisible(true)}
                />
              </GeneralUserInfoRow>
            </div>
          </div>
        )}
      {activePermissions?.includes(
        PermissionEnum.INDIVIDUAL_CUSTOMERS_EDIT_DETAILS_ACTION,
      ) && (
        <div className={cn.generalUserInfoBlock}>
          <div className={cn.formControls}>
            {!edit && status !== CustomerStatus.CLOSED && (
              <ButtonSecondary
                size={ButtonSize.SMALL}
                className={`button-white ${cn.activeEditButton}`}
                text="Edit"
                icon={<IconEdit />}
                onClick={() => setEdit(true)}
              />
            )}
            {edit && (
              <>
                <ButtonSecondary
                  size={ButtonSize.SMALL}
                  text={requestInProgress ? 'Loading...' : 'Save'}
                  className={cn.saveButton}
                  onClick={onInfoSubmit}
                />
                <ButtonSecondary
                  size={ButtonSize.SMALL}
                  className={`button-white ${cn.activeEditButton}`}
                  text="Cancel"
                  onClick={() => setEdit(false)}
                />
              </>
            )}
          </div>
        </div>
      )}
      {/* <GeneralUserInfoApp generalUserInfo={generalUserInfo} /> */}
      {/* <div className={cn.generalUserInfoBlock}>
      <GeneralUserInfoRow
        title="Type of SCA authentications"
        type="default"
        defaultValue={generalUserInfo?.scaAuthenticationsType || '-'}
      />
    </div> */}
    </Card>
  );
};

export default GeneralUserInfo;
